import { defineStore } from "pinia";
import { ref } from "vue";
import { API } from "@/queries/index";
import { AxiosError } from "axios";
import { APIResponse, APIResponseError } from "@/types/api";
import { handleResponse, handleResponseError } from "@/utils/api";
import { MenuPayload, MenuResponse } from "@/types/interface/menu";

export const useMenuStore = defineStore("menuStore", () => {
  const menu = ref<MenuResponse>();
  const menus = ref<MenuResponse[]>([]);

  function initMenus(data: any) {
    menus.value = data?.data;
  }

  function addNewMenu(data: any) {
    menu.value = data;
  }

  async function dispatchGetAll(page = 1, limit = 10, queryParam = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.menu.getMenu(page, limit, queryParam);
      if (status === 200 ) {
        initMenus(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDetail(idMenu = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.menu.findMenu(idMenu);
      if (status === 200 ) {
        addNewMenu(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchCreate(payload:MenuPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.menu.createMenu(payload);
      if (status === 200 ) {
        addNewMenu(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchUpdate(idMenu = "", payload:MenuPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.menu.updateMenu(idMenu, payload);
      if (status === 200 ) {
        addNewMenu(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDelete(idMenu = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.menu.deleteMenu(idMenu);
      if (status === 200 ) {
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  return {
    menu,
    menus,
    initMenus,
    dispatchCreate,
    dispatchUpdate,
    dispatchDetail,
    dispatchGetAll,
    dispatchDelete
  };
});